
export class GeoIPUtils {

    /**
    * Helper function to decode geoIp response
    * @param hex
    * @return
    *
    */
    public static hexStringToBytes(hex: string): number[] {
        let bytes: number[] = [];

        while (hex.length >= 2) {
            bytes.push(Number("0x" + hex.substr(0, 2)));
            hex = hex.substr(2, hex.length - 2);
        }
        return bytes;
    }

    /**
     * Helper function to decode geoIp response
     * @param bytes
     * @return
     */
    public static bytesToAsciiString(bytes: number[]): string {
        let chars: any[] = [];

        for (let byteIndex: number = 0; byteIndex < bytes.length; byteIndex++) {
            chars.push(String.fromCharCode(bytes[byteIndex]));
        }
        return chars.join("");
    }
}
